export default function combineReducers(reducers) {
    return function combined(state = {}, action) {
        let hasChanged = false;
        const combinedState = {};
        const reducerKeys = Object.keys(reducers);
        for (let i = 0; i < reducerKeys.length; i++) {
            const key = reducerKeys[i];
            const reducer = reducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            combinedState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        return hasChanged ? { ...state, ...combinedState } : state;
    };
}
